import React from "react";
import { Route, Routes } from "react-router-dom";
import HomePage from "./Pages/HomePage";
import FollowCursor from "./component/FollowCursor";
import Seo from "./Seo";

// Import Firebase SDKs
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import FAQ from "./Pages/FAQ";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import Terms from "./Pages/Terms";
import HelpSection from "./Pages/HelpCenter";

// Firebase configuration

const firebaseConfig = {
  apiKey: "AIzaSyDEPvWga6mBXSwM71Cl8RNrXsnZW8Ng7O8",
  authDomain: "weplay-web-7e562.firebaseapp.com",
  projectId: "weplay-web-7e562",
  storageBucket: "weplay-web-7e562.firebasestorage.app",
  messagingSenderId: "85432023332",
  appId: "1:85432023332:web:31277cc331ad5d54c6dbb1",
  measurementId: "G-YC8S45GS8J"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
getAnalytics(app);

function App() {
  return (
    <div style={{background:"#000"}} className="App">
      <Seo />
      <FollowCursor />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route exact path="/faqs" element={<FAQ />} />
        <Route exact path="/terms-and-conditions" element={<Terms />} />
        <Route exact path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route exact path="/help-center" element={<HelpSection />} />

      </Routes>
    </div>
  );
}

export default App;
